module.exports = __webpack_public_path__ + "img/share-network-white.cbd0c473.svg";